import cn from 'classnames';
import { useMemo } from 'react';

import { ImageWithGallery } from '@webapp/common/components/image-with-gallery';
import { CssPageBlock } from '@webapp/common/components/survey-custom';
import { setHtml } from '@webapp/common/lib/ui';
import { QuestionParamsModelPairComparisonType } from '@webapp/common/resources/question';

import { usePipingAnswersReplacer } from '@webapp/survey/src/machine/use-piping-answers-replacer';

import css from './pair-comparison.css';

export const PairComparisonAnswer: VFC<{
    textBlock: string;
    imgPath?: string;
    id?: number;
    type: QuestionParamsModelPairComparisonType;
    readOnly?: boolean;
    selected?: boolean;
    onChange?: (id: number, pairNumber: number) => void;
    pairNumber?: number;
    styles?: Record<string, any>;
}> = ({ textBlock, imgPath, type, id, readOnly, selected, onChange, pairNumber, styles }) => {
    const withImage = type === QuestionParamsModelPairComparisonType.IMAGE;
    const pipingAnswersReplacer = usePipingAnswersReplacer();

    const style = useMemo(() => {
        if (styles) {
            return {
                backgroundColor: styles.fieldBorderColor50,
                borderColor: styles.fieldBorderColor,
            };
        }
    }, [styles]);

    const handleChange = () => {
        if (readOnly) return;

        onChange?.(id, pairNumber);
    };

    return (
        <div
            className={cn(CssPageBlock.ANSWER, css.answer, {
                [css.withImage]: withImage,
                [css.selected]: selected,
            })}
            style={{
                // @ts-ignore
                '--hover-color': styles?.fieldBorderColor,
                '--selected-color': styles?.fieldBorderColor50,
            }}
        >
            {withImage ? (
                <>
                    <div {...setHtml(pipingAnswersReplacer(textBlock))} onClick={handleChange} />
                    <ImageWithGallery
                        className={cn(css.imageWrap)}
                        imageUrl={imgPath}
                        alt='pairComparisonImage'
                        onClickWrap={handleChange}
                    />
                </>
            ) : (
                <div
                    {...setHtml(pipingAnswersReplacer(textBlock))}
                    className={cn(css.textBlock)}
                    style={style}
                    onClick={handleChange}
                />
            )}
        </div>
    );
};
